module.exports = __webpack_public_path__ + "img/cards_back-old-3.35a7a02d.png";